import { Component, ViewChild } from '@angular/core';
import { NavParams, Slides } from 'ionic-angular';

import * as $ from 'jquery';

@Component({

   selector: 'page-popover-quantity',
   templateUrl: 'popover-quantity.html'
})

export class PopoverQuantityPage
{

   @ViewChild( 'integerSlide' ) integerSlide: Slides;
   @ViewChild( 'decimalSlide' ) decimalSlide: Slides;

   public integers = [ '', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '' ];
   public decimals = [ '', '.00', '.05', '.10', '.15', '.20', '.25', '.30', '.35', '.40', '.45', '.50', '.55', '.60', '.65', '.70', '.75', '.80', '.85', '.90', '.95', '' ];

   private initVal: string;
   private itemIdx;
   private itemObjIdx;
   private callback;


   /** ----- Constructor ----- **/

   constructor( private params: NavParams )
   {

      this.initVal = this.params.get( 'init' );
      this.itemIdx = this.params.get( 'itemIdx' );
      this.itemObjIdx = this.params.get( 'itemObjIdx' );
      this.callback = this.params.get( 'callback' );

      console.log( "passedin: " + this.initVal );

   }


   ngAfterViewInit()
   {
      let intObj = this.initVal.toString().substring( 0, this.initVal.toString().indexOf( "." ) );
      this.integerSlide.initialSlide = this.integers.indexOf( '' + intObj );

      let decimalObj = this.initVal.toString().substring( 1, 4 );
      this.decimalSlide.initialSlide = this.decimals.indexOf( '' + decimalObj );

   }


   /** ----- UI Callbacks ----- **/

   onSlideChanged()
   {
      let integerIdx = ( this.integerSlide.getActiveIndex() > this.integers.length - 3 ) ? this.integers.length - 3 : this.integerSlide.getActiveIndex();
      let decimalIdx = ( this.decimalSlide.getActiveIndex() > this.decimals.length - 3 ) ? this.decimals.length - 3 : this.decimalSlide.getActiveIndex();
      if ( this.callback != null )
      {
         if ( this.integers[ integerIdx ] != null && this.decimals[ decimalIdx ] != null )
         {
            this.callback( this.itemIdx, this.itemObjIdx, '' + this.integers[ integerIdx + 1] + this.decimals[ decimalIdx + 1 ] );
         }
      }

   }

}



// WEBPACK FOOTER //
// ./src/pages/popover-quantity/popover-quantity.ts